module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":""}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 721
// module chunks = 142629428675168